// extracted by mini-css-extract-plugin
export default {"documentName":"DocumentName_documentName__ZNPLJ"};